import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import { EMPTY_ARRAY, EMPTY_OBJECT, EVENT_TYPES } from '../../constants/globalConstants'
import { globalKeyStore } from '../../redux/actions/globalState'
import Banner from '../../components/global/Banner'
import OffCanvas from '../../components/global/OffCanvas'
import BookingList from '../booking/BookingList'
import {
  //getEventDetails, 
  getFilteredEventList,
  // getMonthEventList,
  getPassDetails
} from '../../redux/actions/MainAction'
import { getConfigDetails } from '../../services/config'
import moment from 'moment-timezone'
import Loader from '../../components/global/Loader'
import MultipleEventCrousel from '../../components/global/MultipleEventCrousel'
import { useNavigate, useParams } from 'react-router-dom'
import Calender from '../../components/global/Calendar'
import { getConvertedDate, getErrorMessage } from '../../utils/helper'
import CONSTANTS from '../../../src/redux/constants'

const Main = ({ selectedPassType, dispatch, noOfEventShow, startDate, passDetails, loader, eventData, partnerDetails, selectedFacilityId, notify, selectedYearForLabel, isLoadingEvent, eventViewStyle, passData }) => {
  // isCanvasShow
  const navigate = useNavigate()
  const [currMonthLoc, setCurrMonthLoc] = useState('')
  const { partner, facility, independant_pass_id } = useParams()
  
  const [facilities, setFacilities] = useState(EMPTY_ARRAY)
  const [disabledUIBtn, setdisabledUIBtn] = useState(false)
  const [typeDetails, setTypeDetails] = useState('')
  const [passId, setPassId] = useState('')
  const [selDate, setSelDate] = useState('')
  const [tab, setTab] = useState('1')
  const [independantPass, setIndependantPass] = useState(false)
  const [independantError, setIndependantError] = useState('')
  const [eventFacility, setEventFacility] = useState(true)
  const [neighborhoodId, setNeighborhoodId] = useState('')
  const [campusList, setCampusList] = useState([])
  const [displayPassList, setDisplayPassList] = useState(false)
  const [tabsChanged, setTabsChanged] = useState(false)
  const tabRef = useRef('1')
  const facilityScrollerRef = useRef(null)

  useEffect(() => {
    const selectedPassID = independant_pass_id ? independant_pass_id : (localStorage.getItem('selectedPass') && localStorage.getItem('selectedPass') != undefined && localStorage.getItem('selectedPass') != 'undefined' && localStorage.getItem('selectedPass') != '') ? localStorage.getItem('selectedPass') : null
    if (selectedPassID) {
      setPassId(() => {
        return selectedPassID
      })
      localStorage.setItem('selectEventType', 'pass')
      tabRef.current = '2'
      setTab('2')
      setdisabledUIBtn(true)
      handlePassManu(selectedPassID)
    } else {
      const localTimeZone = localStorage.getItem('facilitiesTimezone') || 'America/New_York'
      const startDT = moment().tz(`${localTimeZone}`).startOf('month')?.format('YYYY-MM-DD')
      const endDT = moment().tz(`${localTimeZone}`).endOf('month')?.format('YYYY-MM-DD')
      handlePassManu('', '', '', startDT, endDT)
    }

  }, [])

  useEffect(() => {
    if (facilityScrollerRef.current) {
      handleFacilityScroll()
    }
  }, [tab, tabsChanged])

  useEffect(() => {
    let facilityList = facility ? partnerDetails?.facilities?.filter((item) => item?.id == facility) : partnerDetails?.facilities

    let campusData = partnerDetails?.campus?.length > 0 ? partnerDetails?.campus : []
    if (campusData?.length > 0) {
      let campusDataId = campusData?.length > 0 ? campusData[0]?.id : ''
      let facilityFilterByCapmus = facilityList?.filter((item) => item?.neighborhood_id == campusDataId)
      setCampusList(campusData)
      setNeighborhoodId(campusDataId)
      setFacilities(facilityFilterByCapmus)
    } else {
      setFacilities(facilityList)
    }
    window.scrollTo(0, 0)
    // PIMS-11504 Making Static Change for Single Facility Display
    if (partner == 'cityparkinginc') {
      const sortedfacilities = facilityList?.filter((facility) => facility?.id == 674)
      setFacilities(sortedfacilities)
    } else {
      setFacilities(facilityList)
    }
  }, [EMPTY_ARRAY, partner, facility])

  useEffect(() => {
    setTimeout(() => {
      const selLocalFacilityId = facility ? facility : JSON.parse(localStorage?.getItem('selectedFacilityId'))

      let campusData = partnerDetails?.campus?.length > 0 ? partnerDetails?.campus : []
      let campusDataID = campusData?.length > 0 ? campusData[0]?.id : ''
      setNeighborhoodId(campusDataID)

      if (selLocalFacilityId || selectedFacilityId) {
        const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
        dispatch(globalKeyStore({ selectedFacilityId: facility ? facility : eventFacilityid }))
        if (!isNaN(independant_pass_id)) {
          setIndependantPass(true)
          tabRef.current = '2'
          setTab('2')
          setdisabledUIBtn(true)
          handleFaciltyChange(facility, '', '', false, true, true, false, '', '', false, false)
          handlePassManu(Number(independant_pass_id), facility)

        } else {
          setIndependantPass(false)
          // handleFaciltyChange(eventFacilityid)
          handleFaciltyChange(eventFacilityid, '', '', false, true, false, true, campusDataID, '', false, true)
        }
      }
    }, 0)

    const listViewStyle = localStorage.getItem('eventViewStyle')
    if (listViewStyle == 'undefined' || listViewStyle == 'null' || listViewStyle == null) {
      dispatch(globalKeyStore({ eventViewStyle: 'list' }))
    } else {
      dispatch(globalKeyStore({ eventViewStyle: listViewStyle }))
    }


    // setTimeout(() => {
    //   // to filter the date of current month from api:-
    //   const currentSelDate = moment(startDate)?.format('MMM-YYYY')

    //   //api for pass Details 
    //   const passPayloads = { facility_id: getConfigDetails()?.FACILITY_ID }
    //   dispatch(getPassDetails(passPayloads))
    //   localStorage?.setItem('selectEventType', 'event')
    //   localStorage.removeItem('pass_type_slug')
    //   //api for Event Details 
    //   // const eventpayload = { event_type: EVENT_TYPES?.BUNDLE_PASS, facility_id: getConfigDetails()?.FACILITY_ID, pass_id: res?.data[1]?.id }
    //   const eventpayload = { event_type: EVENT_TYPES?.EVENT, facility_id: getConfigDetails()?.FACILITY_ID }

    //   if (eventpayload?.facility_id !== null) {
    //     dispatch(getEventDetails(eventpayload)).then((res) => {
    //       const filterEvents = res?.[currentSelDate] ? res?.[currentSelDate] : []
    //       dispatch(globalKeyStore({ selectedPassType: 0, eventData: filterEvents, selectEventType: 'event' }))
    //     })
    //   } else {
    //     navigate(0)
    //   }

    // }, 0)
  }, [])

  const handleFacilityScroll = () => {
    const scrollContainer = document.getElementById('facility-scroller')
    const targetListItem = facilityScrollerRef.current?.querySelectorAll('input[type="radio"]:checked')
    // const middle = document.getElementById(DateID)
    if (scrollContainer && targetListItem.length > 0) {
      // Calculate the desired scroll position
      const scrollPosition = targetListItem?.[0].offsetLeft - (((scrollContainer.offsetWidth / 2) + (targetListItem?.[0].offsetWidth / 2)) - 80)

      // Set the scrollLeft property
      scrollContainer.scrollTo({
        left: scrollPosition,
        behavior: 'smooth' // Optional: for smooth scrolling
      })
    }
  }

  const handlePassManu = (id, facilityParam = '', currentMonthFull = '', startDT = '', endDT = '') => {
    if (id && tabRef.current == '2' || independant_pass_id) {
      localStorage.setItem('selectedPass', independant_pass_id ? independant_pass_id : id)
      localStorage.setItem('selectEventType', 'pass')
      setPassId(independant_pass_id ? independant_pass_id : id)
    } else {
      localStorage.removeItem('selectedPass')
    }
    let localCategory = JSON.parse(JSON.stringify(passDetails)).filter((item) => {
      return item.id == id
    })
    if (localCategory.length > 0) {
      setTypeDetails(localCategory[0]?.category?.category)
      setPassId(id ? id : localCategory[0]?.id)
      if (localCategory[0]?.category?.category === CONSTANTS.YEAR_PASS) {
        handleListGridView('list')
      }
    } else {
      setTypeDetails('')
      setPassId(id || '')
    }

    // This condition for staging
    if ((localCategory.length > 0 && localCategory[0]?.pass_type_slug == EVENT_TYPES?.BUNDLE_PASS) || localCategory[0]?.pass_type_slug === 'simple-pass') {
      handleListGridView('list')
    }
    const currentSelDate = moment(startDate)?.format('MMM-YYYY')
    const staticToday = (localCategory.length > 0 && localCategory[0]?.facility?.timezone) ? moment().tz(localCategory[0]?.facility?.timezone)?.format('YYYY-MM-D') : moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss')))?.format('YYYY-MM-D')
    const today = selectedYearForLabel ? moment(new Date(selectedYearForLabel))?.format('YYYY-MM-D') : staticToday

    if (id && Number(id) > 0) {
      localStorage.setItem('selectEventType', 'pass')
      localStorage.removeItem('eventData')
      console.log('Here j')
    } else {
      setSelDate('')
      localStorage.removeItem('passData')
      localStorage.setItem('selectEventType', 'event')
    }

    dispatch(globalKeyStore({ selectedPassType: Number(id) }))
    const localFacilityId = localStorage.getItem('selectedFacilityId')
    // const eventpayload = { event_type: id ? EVENT_TYPES?.BUNDLE_PASS : EVENT_TYPES?.EVENT, facility_id: localFacilityId ? localFacilityId : getConfigDetails()?.FACILITY_ID, pass_id: id ? id : '', month_date: (id == 0) ? staticToday : today }
    const eventpayload = {
      event_type: (id && tabRef.current == '2' || independant_pass_id) ? localCategory?.[0]?.pass_type_slug ? localCategory?.[0]?.pass_type_slug : EVENT_TYPES?.BUNDLE_PASS : EVENT_TYPES?.EVENT,
      facility_id: facility ? facility : facilityParam ? facilityParam : localFacilityId ? localFacilityId : getConfigDetails()?.FACILITY_ID,
      start_date: (id == 0) ? moment(staticToday, 'YYYY-MM-D').startOf('month').format('YYYY-MM-DD') : startDT ? startDT : currentMonthFull ? currentMonthFull : moment(today, 'YYYY-MM-D').format('YYYY-MM-DD'),
      end_date: (id == 0) ? moment(staticToday, 'YYYY-MM-D').endOf('month').format('YYYY-MM-DD') : endDT ? endDT : currentMonthFull ? currentMonthFull : moment(today, 'YYYY-MM-D').format('YYYY-MM-DD')
    }
    if ((id && tabRef.current == '2') || independant_pass_id) {
      eventpayload.pass_id = independant_pass_id ? independant_pass_id : id
    }
    dispatch(globalKeyStore({ startValue: (id == 0) ? new Date(staticToday) : new Date(today) }))
    // if(id == '0') {
    //   const selLocalFacilityId = facility ? facility : JSON.parse(localStorage?.getItem('selectedFacilityId'))

    //   if (selLocalFacilityId || selectedFacilityId) {
    //     const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
    //     dispatch(globalKeyStore({ selectedFacilityId: facility ? facility : eventFacilityid }))
    //     handleFaciltyChange(eventFacilityid)
    //   }
    // } else {
    dispatch(getFilteredEventList(eventpayload)).then((res) => {
      if (res?.data) {
        if (eventpayload?.event_type == 'event') {
          if (id && Number(id) > 0) {
            localStorage.setItem('selectEventType', 'pass')
            localStorage.removeItem('eventData')
          } else {
            setSelDate('')
            localStorage.removeItem('passData')
            localStorage.setItem('selectEventType', 'event')
            localStorage.removeItem('pass_type_slug')
          }

          const filterEvents = res?.data?.[currentSelDate] ? res?.data?.[currentSelDate] : []
          const EventsDates = res?.data?.eventsByMonth ? res?.data?.eventsByMonth : []
          if (facilityParam) {
            dispatch(globalKeyStore({ selectedPassType: eventpayload?.event_type == 'event' ? 0 : Number(id), eventData: filterEvents, selectEventType: 'pass', selectedFacilityId: localFacilityId, calendarDates: EventsDates, allEventsData: filterEvents }))
          } else {
            dispatch(globalKeyStore({ selectedPassType: eventpayload?.event_type == 'event' ? 0 : Number(id) ? Number(id) : 0, eventData: filterEvents, selectEventType: 'event', selectedFacilityId: localFacilityId, calendarDates: EventsDates, allEventsData: filterEvents }))
          }
        } else {
          setSelDate('')
          // localStorage.removeItem('passData')
          // localStorage.setItem('selectEventType', 'event')
          // localStorage.removeItem('pass_type_slug')
          localStorage.setItem('passData', JSON.stringify(res?.data))
          localStorage?.setItem('pass_type_slug', res?.data?.pass_type_slug)
          dispatch(globalKeyStore({ passData: res?.data, selectEventType: 'pass' }))
        }
        // localStorage.setItem('passData', JSON.stringify(res?.data))
        if(res?.data && !res?.data?.id && isNaN(eventpayload?.facility_id)) {
          navigate('/'+partner)
          navigate(0)
        }
      } else {
        if(facility) {
          navigate('/'+partner)
          navigate(0)
        }
        if (independant_pass_id) {
          let err = getErrorMessage(res)
          setIndependantError(err)
        }
        localStorage.setItem('passData', JSON.stringify({}))
        dispatch(globalKeyStore({ selectedPassType: 0, eventData: [], calendarDates: [], selectEventType: 'event', selectedFacilityId: localFacilityId }))
      }
      // localStorage?.setItem('pass_type_slug', res?.data?.pass_type_slug)
      // dispatch(globalKeyStore({ selectedPassType: id, passData: res, selectEventType: 'pass' }))
    }).catch((error) => {
      if(facility) {
        navigate('/'+partner)
        navigate(0)
      }
      notify('error', error?.errors?.message ? error?.errors?.message : 'No event found!')
      localStorage.setItem('passData', JSON.stringify({}))

      dispatch(globalKeyStore({ selectedPassType: 0, eventData: [], calendarDates: [], selectEventType: 'event', selectedFacilityId: localFacilityId }))
    })
    //}
  }

  const loadMore = () => {
    dispatch(globalKeyStore({ noOfEventShow: noOfEventShow + 4 }))
  }

  // const handleOffCanvas = () => {
  //   dispatch(globalKeyStore({ isCanvasShow: !isCanvasShow }))
  // }

  const handleCampusChange = (value, currMonth = '', currYear = '', changeFac = false, onlyEvents = true, pass_indep = false, onlyFacility = false) => {
    setNeighborhoodId(value)
    setSelDate('')
    setCurrMonthLoc('')
    let facilityList = partnerDetails?.facilities?.filter((item) => item?.neighborhood_id == value)
    setFacilities(facilityList)
    handleFaciltyChange(selectedFacilityId, currMonth, currYear, changeFac, onlyEvents, pass_indep, onlyFacility, value, '', false, false)
  }

  const resetCampusHandle = (e, value, currMonth = '', currYear = '', changeFac = false, onlyEvents = true, pass_indep = false, onlyFacility = false) => {

    if (value == neighborhoodId) {
      setNeighborhoodId(value)
      setSelDate('')
      setCurrMonthLoc('')
      let facilityList = partnerDetails?.facilities?.filter((item) => item?.neighborhood_id == value)
      setFacilities(facilityList)
      handleFaciltyChange(selectedFacilityId, currMonth, currYear, changeFac, onlyEvents, pass_indep, onlyFacility, value, '', false, false)
    }

    // handleCampusChange(value, currMonth = '', currYear = '', changeFac = false, onlyEvents = true, pass_indep = false,onlyFacility = false)
  }

  const handleFaciltyChange = (value, currMonth = '', currYear = '', changeFac = false, onlyEvents = true, pass_indep = false, onlyFacility = false, campusId = '', currentMonthFull = '', onlyPass = false, pageLoad = false) => {
    // const { value } = e.target
    const localTimeZone = localStorage.getItem('facilitiesTimezone') || 'America/New_York'
    // to filter the date of current month from api:-
    const currentSelDate = (currMonth != '' && currYear != '') ? moment().month(currMonth).year(currYear).format('MMM-YYYY') : moment(startDate)?.format('MMM-YYYY')
    const today = selectedYearForLabel ? moment(new Date(selectedYearForLabel))?.format('YYYY-MM-D') : moment().tz(`${localTimeZone}`)?.format('YYYY-MM-D')
    const filterData = partnerDetails?.facilities?.filter((item) => Number(item?.id) == Number(value))
    const start_date = (currentMonthFull) ? moment(currentMonthFull, 'YYYY-MM-DD').startOf('month').format('YYYY-MM-DD') : (selectedYearForLabel) ? moment(selectedYearForLabel, 'YYYY-MM-DD').startOf('month').format('YYYY-MM-DD') : moment().tz(filterData?.[0]?.timezone ? filterData?.[0]?.timezone : 'America/New_York').startOf('month').format('YYYY-MM-DD')
    const end_date = (currentMonthFull) ? moment(currentMonthFull, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD') : (selectedYearForLabel) ? moment(selectedYearForLabel, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD') : moment().tz(filterData?.[0]?.timezone ? filterData?.[0]?.timezone : 'America/New_York').endOf('month').format('YYYY-MM-DD')
    if (value && value > 0) {
      //api for pass Details
      let passPayloads = {
        facility_id: value,
        start_date: start_date,
        end_date: end_date
      }
      // if(onlyFacility && campusId!=''){
      //   setEventFacility(true)        
      //   passPayloads={...passPayloads,'all_event':onlyFacility ?'1':'0',facility_id:'',campus_id:campusId}
      // }else{
      //   setEventFacility(false)
      // }
      if (onlyEvents || onlyPass) {
        dispatch(getPassDetails(passPayloads)).then((resp) => {
          setTabsChanged(!tabsChanged)
          let passDetails = []
          resp?.map((item) => {
            passDetails.push({ 'pass_id': item.id, 'facility_id': item.facility_id, 'is_pass_sold': item.is_pass_sold })
          })
          localStorage.setItem('passDetails', JSON.stringify(passDetails))
          setPassId(passDetails?.[0]?.pass_id)
          dispatch(globalKeyStore({ selectedPassType: pageLoad ? 0 : passDetails?.[0]?.pass_id }))
          // callEventsList(value, today, onlyFacility, campusId, start_date, end_date, changeFac, currMonth, pass_indep, filterData, currentSelDate)
          if (!onlyPass || (onlyPass && passDetails?.length > 0)) {
            dispatch(globalKeyStore({ selectedFacilityId: value }))
            handlePassManu(passDetails?.[0]?.pass_id, '', '', tabRef.current == '1' ? start_date : '', tabRef.current == '1' ? end_date : '')
          } else {
            dispatch(globalKeyStore({
              allEventsData: [],
              eventData: [],
              passData: {}
            }))
          }
        })
      }
      //  FOR LOCAL STATE
      localStorage.setItem('selectedFacilityId', value)
      dispatch(globalKeyStore({ selectedFacilityId: value }))
      if (!onlyPass) {
        const passId = independant_pass_id ? independant_pass_id : (localStorage.getItem('selectedPass') && localStorage.getItem('selectedPass') != undefined && localStorage.getItem('selectedPass') != 'undefined' && localStorage.getItem('selectedPass') != '') ? localStorage.getItem('selectedPass') : null
        if (passId) {
          localStorage.setItem('selectEventType', 'pass')
        } else {
          localStorage?.setItem('selectEventType', 'event')
          localStorage.removeItem('pass_type_slug')
        }

        const type = independant_pass_id ? 'pass' : localStorage.getItem('selectEventType')
        const selectedPass = independant_pass_id ? independant_pass_id : localStorage.getItem('selectedPass')
        if (type == 'pass') {
          handlePassManu(selectedPass, '', currentMonthFull, start_date, end_date)
        } else if (!onlyEvents) {
          callEventsList(value, today, onlyFacility, campusId, start_date, end_date, changeFac, currMonth, pass_indep, filterData, currentSelDate, pageLoad)
        }
      }
    } else {
      localStorage.removeItem('selectedFacilityId')
      dispatch(globalKeyStore({ selectedFacilityId: null }))
    }
  }

  const callEventsList = (value, today, onlyFacility, campusId, start_date, end_date, changeFac, currMonth, pass_indep, filterData, currentSelDate) => {
    let eventpayload = { event_type: EVENT_TYPES?.EVENT, facility_id: value, month_date: today }
    if (onlyFacility && campusId != '') {
      setEventFacility(true)
      eventpayload = { ...eventpayload, 'all_event': onlyFacility ? '1' : '0', facility_id: '', campus_id: campusId }
    } else {
      setEventFacility(false)
    }
    dispatch(globalKeyStore({ startValue: new Date(today) }))
    if (eventpayload?.facility_id !== null) {

      delete eventpayload.month_date
      // if(currentMonthFull) {

      eventpayload.start_date = start_date
      eventpayload.end_date = end_date
      dispatch(getFilteredEventList(eventpayload)).then((res) => {
        const curMonth = moment(end_date, 'YYYY-MM-DD').format('MMM-YYYY')
        // dispatch(getFilteredEventList(eventpayload)).then((res) => {
        // const filterEvents = (changeFac && currMonthLoc && currMonth == '') ? res?.data?.[curMonth] : res?.data?.[currentSelDate] ? res?.data?.[currentSelDate] : []
        const filterEvents = ((changeFac) && (currMonthLoc) && currMonth == '') ? res?.data?.[curMonth] : res?.data?.[currentSelDate] ? res?.data?.[currentSelDate] : []
        const EventsDates = res?.data?.eventsByMonth ? res?.data?.eventsByMonth : []
        const EventsData = []
        for (const property in res?.data) {
          if (property != 'eventsByMonth') {
            EventsData.push(res?.data[property])
          }
        }
        const selectedPassID = independant_pass_id ? independant_pass_id : (localStorage.getItem('selectedPass') && localStorage.getItem('selectedPass') != undefined && localStorage.getItem('selectedPass') != 'undefined' && localStorage.getItem('selectedPass') != '') ? localStorage.getItem('selectedPass') : null
        dispatch(globalKeyStore({
          selectedPassType: independant_pass_id ? independant_pass_id : (pass_indep) ? Number(independant_pass_id) : selectedPassID ?? 0, eventData: filterEvents, selectEventType: 'event',
          selectedFacilityId: value,
          allEventsData: (EventsData.length > 0) ? EventsData.flat() : [],
          calendarDates: EventsDates
        }))
      })

      // } else {
      //   dispatch(getMonthEventList(eventpayload)).then((res) => {
      //     const filterEvents = (changeFac && currMonthLoc && currMonth == '') ? res?.data?.[currMonthLoc] : res?.data?.[currentSelDate] ? res?.data?.[currentSelDate] : []
      //     const EventsData = []
      //     for (const property in res?.data) {
      //       EventsData.push(res?.data[property])
      //     }
      //     const selectedPassID = (localStorage.getItem('selectedPass') && localStorage.getItem('selectedPass') != undefined  && localStorage.getItem('selectedPass') != 'undefined' && localStorage.getItem('selectedPass') != '') ? localStorage.getItem('selectedPass') : null

      //     dispatch(globalKeyStore({ selectedPassType: pass_indep ? Number(independant_pass_id) : selectedPassID ? selectedPassID : 0, eventData: filterEvents, selectEventType: 'event', selectedFacilityId: value, allEventsData: EventsData.flat() }))
      //   })
      // }


      // time zone start faclity time zone save
      localStorage.setItem('facilitiesTimezone', filterData?.[0]?.timezone ? filterData?.[0]?.timezone : 'America/New_York')
      dispatch(globalKeyStore({ facilitiesTimezone: filterData?.[0]?.timezone ? filterData?.[0]?.timezone : 'America/New_York' }))

      // time zone end 
    } else {
      navigate(0)
    }
  }

  // API CALL FOR FILTERING THE EVENTS 
  const handleSelectingDate = (date) => {
    dispatch(globalKeyStore({ selectedYearForLabel: date }))
    const eventType = localStorage.getItem('pass_type_slug')
    const localFacilityId = JSON.parse(localStorage.getItem('selectedFacilityId'))
    const currentSelDate = moment(date)?.format('MMM-YYYY')
    const selectedPassID = independant_pass_id ? independant_pass_id : (localStorage.getItem('selectedPass') && localStorage.getItem('selectedPass') != undefined && localStorage.getItem('selectedPass') != 'undefined' && localStorage.getItem('selectedPass') != '') ? localStorage.getItem('selectedPass') : null

    let payload = {
      'event_type': ((eventType) && eventType !== undefined && eventType !== null) ? eventType : 'event',
      'facility_id': facility ? facility : localFacilityId,
      'start_date': date,
      'end_date': date,
      'pass_id': (selectedPassType || selectedPassID) ? selectedPassType || selectedPassID : ''
    }
    if (eventFacility && neighborhoodId != '') {
      setEventFacility(true)
      payload = { ...payload, 'all_event': eventFacility ? '1' : '0', facility_id: '', campus_id: neighborhoodId }
    } else {
      setEventFacility(false)
    }
    dispatch(globalKeyStore({ startValue: new Date(date) }))
    dispatch(getFilteredEventList(payload)).then((res) => {
      if (res?.data !== null) {
        if (payload?.event_type == 'event') {
          localStorage?.setItem('selectEventType', 'event')
          localStorage.removeItem('pass_type_slug')
          const filterEvents = res?.data?.[currentSelDate] ? res?.data?.[currentSelDate] : []
          const EventsDates = res?.data?.eventsByMonth ? res?.data?.eventsByMonth : []
          dispatch(globalKeyStore({ selectedPassType: 0, eventData: filterEvents, allEventsData: filterEvents, calendarDates: EventsDates, selectEventType: 'event', selectedFacilityId: localFacilityId }))
        } else {
          localStorage.setItem('passData', JSON.stringify(res?.data))
          localStorage?.setItem('pass_type_slug', res?.data?.pass_type_slug)
          dispatch(globalKeyStore({ passData: res?.data, selectEventType: 'pass' }))
        }
      } else {
        notify('error', res?.errors?.message ? res?.errors?.message : 'No event found!')
        localStorage.setItem('passData', JSON.stringify({}))

        dispatch(globalKeyStore({ selectedPassType: 0, eventData: [], calendarDates: [], selectEventType: 'event', selectedFacilityId: localFacilityId }))
      }
    }).catch((error) => {
      notify('error', error?.errors?.message ? error?.errors?.message : 'No event found!')
      localStorage.setItem('passData', JSON.stringify({}))

      dispatch(globalKeyStore({ selectedPassType: 0, eventData: [], calendarDates: [], selectEventType: 'event', selectedFacilityId: localFacilityId }))
    })
    if (tab === '2') {
      let passPayloads = {
        facility_id: facility ? facility : localFacilityId,
        start_date: date,
        end_date: date
      }
      // if(onlyFacility && campusId!=''){
      //   setEventFacility(true)        
      //   passPayloads={...passPayloads,'all_event':onlyFacility ?'1':'0',facility_id:'',campus_id:campusId}
      // }else{
      //   setEventFacility(false)
      // }
      dispatch(getPassDetails(passPayloads)).then((resp) => {
        let passDetails = []
        resp?.map((item) => {
          passDetails.push({ 'pass_id': item.id, 'facility_id': item.facility_id, 'is_pass_sold': item.is_pass_sold })
        })
        localStorage.setItem('passDetails', JSON.stringify(passDetails))
        setPassId(passDetails?.[0]?.pass_id)
        dispatch(globalKeyStore({ selectedPassType: passDetails?.[0]?.pass_id }))
        // callEventsList(value, today, onlyFacility, campusId, start_date, end_date, changeFac, currMonth, pass_indep, filterData, currentSelDate)
        handlePassManu(passDetails?.[0]?.pass_id)
      }).catch((error) => {
        notify('error', error?.errors?.message ? error?.errors?.message : 'No pass found!')
      })
    }
  }
  // END OF API CALL

  const handleListGridView = (value) => {
    dispatch(globalKeyStore({ eventViewStyle: value }))
  }

  const getMonth = () => {
    return moment(new Date(selectedYearForLabel))?.format('MMMM	YYYY')
  }



  const tabChange = (id) => {
    if (id == '1') {
      setdisabledUIBtn(false)
      localStorage.setItem('selectEventType', 'event')
      localStorage.removeItem('selectedPass')
      handleFaciltyChange(selectedFacilityId, '', '', true, false, false, false, '', '', false, true)
    } else {
      handleFaciltyChange(selectedFacilityId, '', '', false, true, false, '', '', '', false, false)
      // handleFaciltyChange(selectedFacilityId, '', '', false, true, false, '', '')
      setdisabledUIBtn(true)
    }
    tabRef.current = id
    setTab(id)
  }

  const togglePassList = () => {
    setDisplayPassList(!displayPassList)
  }



  return (
    (loader) ? <div className='d-flex align-content-center flex-wrap vh-100 justify-content-center'><Loader /></div> : <div>
      <Banner partnerDetails={partnerDetails} />
      <div className="container mt-3"  >
        {!independantPass ? <>
          <ul className="nav customNavs nav-pills justify-content-center mb-2 gap-2 pb-4 border-bottom">
            <li className='nav-item'>
              <a className={`${(tab === '1') ? 'active ' : ''}nav-link border p-3 px-5`} onClick={() => tabChange('1')} style={{
                fontSize: '20px',
                fontWeight: 'bold'
              }}>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/4358/4358423.png"
                  height="30px"
                  className="d-inline-block"
                  style={(tab === '1') ? {
                    filter: 'invert(1)',
                    marginTop: '-7px',
                    marginRight: '10px'
                  } : {
                    marginTop: '-7px',
                    marginRight: '10px'
                  }}
                  alt="Events"
                />
                Events
              </a>
            </li>
            <li className="nav-item">
              {/* <a className={`${(tab === '2' && passDetails?.length > 0) ? 'active ' : passDetails?.length > 0 ? '' : 'disable '}nav-link border p-3 px-5`} aria-current="page" onClick={() => tabChange('2')} style={{ */}
              <a className={`${(tab === '2') ? 'active ' : ''}nav-link border p-3 px-5`} aria-current="page" onClick={() => tabChange('2')} style={{
                fontSize: '20px',
                fontWeight: 'bold'
              }}>
                <img
                  height="30px"
                  src="https://cdn-icons-png.flaticon.com/512/7466/7466947.png"
                  className="d-inline-block"
                  style={tab === '2' ? {
                    filter: 'invert(1)',
                    lineHeight: '0',
                    verticalAlign: 'middle',
                    marginRight: '9px',
                    marginTop: '-7px'
                  } : {
                    lineHeight: '0',
                    verticalAlign: 'middle',
                    marginRight: '9px',
                    marginTop: '-7px'
                  }}
                  alt="Passes"
                />
                Passes
              </a>
            </li>
          </ul>
          {(tab === '1') ? <div className="row mb-3 align-items-end justify-content-between" id="filters" style={{ minHeight: '40px' }}>
            <div className="col-sm-auto col-12 order-0 ">
              {tab === '1' ? <h4 className="fw-bold  h2 mb-0">Latest Event in <span className="text-primary">{`"${getMonth()}"`}</span></h4> : ''}
            </div>
            {(selectedFacilityId) && <div className="col-auto d-sm-block d-none">

              <div className="btn-group ">
                <button className={(eventViewStyle == 'list') ? 'btn btn-dark' : 'btn btn-outline-dark'} type='button' value='list' onClick={() => handleListGridView('list')} disabled={disabledUIBtn}><i className="fa-solid fa-list"></i></button>
                <button className={(eventViewStyle == 'Grid') ? 'btn btn-dark' : 'btn btn-outline-dark'} type='button' value='Grid' onClick={() => handleListGridView('Grid')} disabled={disabledUIBtn}> <i className="fa-solid fa-grip"></i></button>
              </div>
              {/* <button type='button' className="btn btn-outline-primary" onClick={() => handleOffCanvas()}> <i className="fa-solid fa-filter"></i></button> */}

              {/* <div className=" d-block d-sm-none ">
                  <button type='button' className="btn btn-outline-primary" onClick={() => handleOffCanvas()}> <i className="fa-solid fa-filter"></i></button>
                </div> */}
            </div>}
          </div> : ''}

          {/* as per Hemant sir guidensess calender is comented  */}
          <div className={`${tab === '1' ? 'border-top py-3' : 'pb-3 pt-2'} border-bottom`}>
            <Calender handleSelectingDate={handleSelectingDate} handleFaciltyChange={handleFaciltyChange} setCurrMonthLoc={setCurrMonthLoc} selDate={selDate} setSelDate={setSelDate} eventFacility={eventFacility} campusDataID={eventFacility ? neighborhoodId : ''} tab={tab} />
          </div>
          {/* for the Selection of the facilities */}
          <div className="py-3 border-bottom">
            {tab === '1' ? <div className="row align-items-center border-bottom pb-2 mb-3">
              {/* {(facilities?.length > 1) && <div className="col-sm-auto col-6 order-0">
              <h4 style={{minWidth:'180px'}} className="fw-bold text-primary"></h4>
            </div>} */}

              <div className="col-sm col-12 order-3 order-sm-1 text-center facilitySelector" action="#">
                <div className="text-left wrapScroller" role="group" aria-label="Basic radio toggle" >

                  {campusList.length > 0 ? (campusList)?.map((item, index) => {
                    return (
                      <>
                        <input type="radio" className="btn-check" name="facilityName" id={`facilityName${index + 2}`} value={item?.id} onChange={(e) => handleCampusChange(e.target?.value, '', '', true, false, false, true)} checked={(eventFacility && item?.id == neighborhoodId) ? true : false} />
                        <label role="button" className="btn py-2 px-3 btn-outline-primary mx-2 mb-0" htmlFor={`facilityName${index + 2}`} onClick={(e) => resetCampusHandle(e, item?.id, '', '', true, false, false, true)}>
                          <b className="mb-0 fw-bold" > <i className="fa fa-map-marker me-2" aria-hidden="true"></i> {item?.title}</b>
                        </label>
                      </>
                    )


                  }) : null}
                </div>
              </div>
            </div> : null}
            {/* facility lot with  */}
            <div className="row align-items-center ">
              {(facilities?.length > 1) && <div className="col-sm-auto col-6 order-0">
                <h4 style={{ minWidth: '180px' }} className="fw-bold text-primary">Choose Facility</h4>
              </div>}

              <div className="col-sm col-12 order-3 order-sm-1 facilitySelector" action="#">
                <div id='facility-scroller' ref={facilityScrollerRef} className="text-left wrapScroller" role="group" aria-label="Basic radio toggle" >
                  {/* <input type="radio" className="btn-check" name="facility" value={0} onChange={(e) => handleFaciltyChange(e.target?.value)} id='facility1' checked={!selectedFacilityId ? true : false} defaultChecked />
                          <label className="btn p-3 btn-outline-primary mx-2" htmlFor='facility1'>
                              <b className="mb-0 fw-bold" > <i className="fa fa-map-marker me-2" aria-hidden="true"></i> All Facility</b>
                          </label> */}
                  {(facilities)?.map((item, index) => {
                    // if(item?.neighborhood_id==neighborhoodId){
                    return (
                      <>
                        <input type="radio" className="btn-check" name="facility" id={`facility${index + 2}`} value={item?.id} onChange={(e) => handleFaciltyChange(e.target?.value, '', '', true, false, false, false, '', '', tabRef.current == '2' ? true : false, false)} checked={(item?.id == selectedFacilityId) ? true : false} />
                        <label className="btn py-2 px-3 btn-outline-primary mx-2 mb-0" htmlFor={`facility${index + 2}`}>
                          <b className="mb-0 fw-bold" > <i className="fa fa-map-marker me-2" aria-hidden="true"></i> {item?.full_name}</b>
                        </label>
                      </>
                    )
                    // }
                  })}
                </div>
              </div>
            </div>
          </div>
          {tab === '2' ? <div className="row mb-3 mt-2" id="filters" style={{ minHeight: '40px' }}>
            {(selectedFacilityId) && <><div className="col-auto d-none d-sm-block">
              <a className='btn btn-outline-dark' onClick={togglePassList}><i className={`${displayPassList ? 'fa-minus' : 'fa-plus'} fa`}></i></a>
            </div>
              <div className='col-sm d-none d-sm-block overflow-hidden overflow-x-auto scrollbarStyling pb-2 p-0'>
                <ul className={`${displayPassList ? 'flex-wrap ' : ''}EventListSection`}>
                  {/* {[...[{ description: 'All Events', id: 0 }], ...passDetails]?.map((item, index) => <li className="nav-item" key={index}> */}
                  {passDetails?.map((item, index) => <li className="nav-item" key={index}>
                    <span className={(item?.id == selectedPassType || item.id == passId) ? 'nav-link active' : 'nav-link'} value={item?.id} id={item?.id} aria-current="page" onClick={() => handlePassManu(item?.id)}>{item?.description}</span>
                  </li>
                  )}
                </ul>
              </div>

              <select name="" className="form-select mt-3  d-block d-sm-none" aria-label="Default select example" onChange={(e) => handlePassManu(e.target.value)}>
                {/* {[...[{ description: 'All Events', id: 0 }], ...passDetails]?.map((item, index) => <option style={{ overflow: 'ellipsis' }} value={item?.id} selected={item?.id == selectedPassType ? true : false} key={index} >{item?.description}</option>)} */}
                {passDetails?.map((item, index) => <option style={{ overflow: 'ellipsis' }} value={item?.id} selected={(item?.id == selectedPassType || item.id == passId) ? true : false} key={index} >{item?.description}</option>)}
              </select>

            </>}
            {(selectedFacilityId) && <div className="col-auto d-sm-block d-none">

              <div className="btn-group ">
                <button className={(eventViewStyle == 'list') ? 'btn btn-dark' : 'btn btn-outline-dark'} type='button' value='list' onClick={() => handleListGridView('list')} disabled={disabledUIBtn}><i className="fa-solid fa-list"></i></button>
                <button className={(eventViewStyle == 'Grid') ? 'btn btn-dark' : 'btn btn-outline-dark'} type='button' value='Grid' onClick={() => handleListGridView('Grid')} disabled={disabledUIBtn}> <i className="fa-solid fa-grip"></i></button>
              </div>
              {/* <button type='button' className="btn btn-outline-primary" onClick={() => handleOffCanvas()}> <i className="fa-solid fa-filter"></i></button> */}

              {/* <div className=" d-block d-sm-none ">
                    <button type='button' className="btn btn-outline-primary" onClick={() => handleOffCanvas()}> <i className="fa-solid fa-filter"></i></button>
                  </div> */}
            </div>}
          </div> : ''}
        </> : ''}
        {((((selectedPassType == 0 && tab == '1') && selectedFacilityId && eventData?.length > 0) || (selectedFacilityId && passData?.all_event?.length > 0)) && !independant_pass_id) ?
          <div className='pt-4'>
            {((selectedPassType == 0 && tab == '1') || !selectedPassType) ? 'All Events' : passDetails.filter((item) => item.id == selectedPassType)?.map((item) => item.description)}- <strong className='text-dark font-weight-bold'>&ldquo;{(selectedPassType == 0 && selectedFacilityId) ? eventData?.length : (selectedFacilityId && passData?.all_event?.length) ? passData.all_event.length : '0'} event{Number((selectedPassType == 0 && selectedFacilityId) ? eventData?.length : (selectedFacilityId && passData?.all_event?.length) ? passData.all_event.length : '0') === 1 ? '' : 's'} found&rdquo;</strong>
          </div> : ''
        }
        {(isLoadingEvent) ? <Loader /> : independantError ? <p className='h4 text-primary text-center my-5 px-2'>{independantError}</p> : <div>
          {(tab == '1') && (selectedFacilityId) ? <div className={`row row-cols-1 g-4 mt-0  ${(eventViewStyle == 'list') ? 'row-cols-sm-1 list' : ' row-cols-sm-3 column '}`}>
            <BookingList isMainScreen typeDetails={typeDetails} passId={passId} eventFacility={eventFacility} notify={notify} selectedFacilityId={selectedFacilityId} />
          </div> : (selectedFacilityId) ? <MultipleEventCrousel isMainScreen hidePaymentDetails eventViewStyle={eventViewStyle} typeDetails={typeDetails} passId={passId} notify={notify} independantPass={independantPass} independant_pass_id={independant_pass_id} /> : null}

        </div>}

        <div className=" my-4 d-block text-center">
          {(selectedPassType == 0 && eventData?.length > 4 && (noOfEventShow < eventData?.length)) ? <button className="btn btn-secondary px-5" onClick={() => loadMore()}><i className="fa fa-refresh"></i> More Events</button> : null}
        </div>
      </div>
      <OffCanvas />
    </div >
  )
}

Main.propTypes = {
  dispatch: PropTypes.func,
  notify: PropTypes.func,
  globalData: PropTypes.object,
  selectedPassType: PropTypes.number,
  noOfEventShow: PropTypes.number,
  isCanvasShow: PropTypes.bool,
  startDate: PropTypes.string,
  passDetails: PropTypes.array,
  loader: PropTypes.bool,
  eventData: PropTypes.array,
  partnerDetails: PropTypes.object,
  selectedFacilityId: PropTypes.string,
  selectedYearForLabel: PropTypes.string,
  isLoadingEvent: PropTypes.bool,
  passData: PropTypes.EMPTY_OBJECT,
  eventViewStyle: PropTypes.string
}

Main.defaulProps = {
  dispatch: noop,
  globalData: EMPTY_OBJECT,
  notify: noop,
  selectedPassType: '',
  noOfEventShow: 4,
  isCanvasShow: false,
  startDate: new Date(),
  passDetails: EMPTY_ARRAY,
  loader: false,
  eventData: EMPTY_ARRAY,
  partnerDetails: EMPTY_OBJECT,
  selectedFacilityId: '',
  selectedYearForLabel: '',
  isLoadingEvent: false,
  passData: EMPTY_OBJECT,
  eventViewStyle: ''
}

function mapStateToProps({ globalReducers, mainReducer }) {
  return {
    selectedPassType: globalReducers?.selectedPassType,
    noOfEventShow: globalReducers?.noOfEventShow,
    isCanvasShow: globalReducers?.isCanvasShow,
    startDate: globalReducers?.startValue,
    passDetails: mainReducer?.passDetails,
    loader: mainReducer?.loader,
    eventData: globalReducers?.allEventsData,
    partnerDetails: globalReducers?.partnerDetails,
    selectedFacilityId: globalReducers?.selectedFacilityId,
    selectedYearForLabel: globalReducers?.selectedYearForLabel,
    isLoadingEvent: mainReducer?.isloader,
    passData: globalReducers?.passData,
    eventViewStyle: globalReducers?.eventViewStyle,
  }
}

export default connect(mapStateToProps)(Main)